import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EditorComponent } from 'ngx-monaco-editor-v2';

@Component({
  selector: 'app-monaco-editor',
  imports: [FormsModule, EditorComponent],
  templateUrl: './monaco-editor.component.html',
  standalone: true,
})
export class MonacoEditorComponent {
  @Input() lang: string = 'javascript';
  @Input() code: string;
  @Output() codeChange = new EventEmitter<string>();

  editorOptions;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.lang) this.setEditorOption();
  }

  setEditorOption() {
    this.editorOptions = {
      language: this.lang,
      minimap: { enabled: false },
      scrollBeyondLastLine: false,
      lineHeight: 20,
      fontSize: 14,
      wordWrap: 'on',
      theme: 'vs-dark',
      wrappingIndent: 'indent',
      automaticLayout: true,
    };
  }

  onChanges() {
    this.codeChange.emit(this.code);
  }
}
